const eyesProtectGuide = [{
    path: '/eyes_protect_guide',
    name: 'eyes-protect-guide',
    component() {
      return import('@/views/page/eyes_protect_guide.vue')
    },
    meta: {
        title: ' '
    }
}]
export default eyesProtectGuide
